<div class="wrapper" *ngIf="false">
  <ng-container *ngFor="let item of attachments;let i =index">
    <input [checked]="i==0?true:false" type=radio name="slider" [id]="'slide'+(i+1)" />

  </ng-container>
  <!-- storage_url+ item.cdnPath -->
  <!-- <input type=radio name="slider" id="slide2" />
  <input type=radio name="slider" id="slide3" />
  <input type=radio name="slider" id="slide4" />
  <input type=radio name="slider" id="slide5" /> -->

  <div class="slider-wrapper">
    <div class=inner>
      <article *ngFor="let item of attachments;let i =index">
        <!-- <div class="info top-left">
          <h3>Malacca</h3>
        </div> -->
        <img [src]="storage_url+ item.cdnPath" />

      </article>

      <!-- <article>
        <div class="info bottom-right">
          <h3>Cameron Highland</h3>
        </div>
        <img src="https://farm6.staticflickr.com/5812/23394215774_b76cd33a87_h_d.jpg" />
      </article>

      <article>
        <div class="info bottom-left">
          <h3>New Delhi</h3>
        </div>
        <img src="https://farm8.staticflickr.com/7455/27879053992_ef3f41c4a0_h_d.jpg" />
      </article>

      <article>
        <div class="info top-right">
          <h3>Ladakh</h3>
        </div>
        <img src="https://farm8.staticflickr.com/7367/27980898905_72d106e501_h_d.jpg" />
      </article>

      <article>
        <div class="info bottom-left">
          <h3>Nubra Valley</h3>
        </div>
        <img src="https://farm8.staticflickr.com/7356/27980899895_9b6c394fec_h_d.jpg" />
      </article> -->
    </div>
    <!-- .inner -->
  </div>
  <!-- .slider-wrapper -->

  <div class="slider-prev-next-control">
    <ng-container *ngFor="let item of attachments;let i=index">
      <label [for]="'slide'+(i+1)"></label>
      <!-- <label for=slide2></label>
      <label for=slide3></label>
      <label for=slide4></label>
      <label for=slide5></label> -->
    </ng-container>


  </div>
  <!-- .slider-prev-next-control -->

  <div class="slider-dot-control">
    <ng-container *ngFor="let item of attachments ;let i=index">
      <label [for]="'slide'+(i+1)"></label>
      <!-- <label for=slide2></label>
      <label for=slide3></label>
      <label for=slide4></label>
      <label for=slide5></label> -->
    </ng-container>
  </div>
  <!-- .slider-dot-control -->
</div>


<div class="w-100">
  <ngb-carousel #carousel [interval]="81000000" [pauseOnHover]="pauseOnHover" (slide)="onSlide($event)"
    [showNavigationArrows]="false" [showNavigationIndicators]="false">
    <ng-template ngbSlide *ngFor="let img of attachments; index as i">
      <!-- <div class="carousel-caption">
        <h3>My slide {{i + 1}} title</h3>
      </div> -->
      <!-- <a href="https://www.google.fr/?q=Number+{{i+1}}" target="_blank" rel="nofollow noopener noreferrer"> -->
      <div class="picsum-img-wrapper w-100">
        <img [src]="storage_url + img.cdnPath" alt="My image {{i + 1}} description" class="w-100" />
      </div>
      <!-- </a> -->
    </ng-template>
  </ngb-carousel>
</div>
